<template>
  <div class="tncWrapper mb-5">
    <el-checkbox v-model="agreeTnc" data-testid="checkbox" class="agreeTnc text-xs">
      <span>
        {{ $t('promotion.noDepositBonus.agreeTnc')
        }}<a :href="tncUrl" target="_blank" data-testid="tnc">{{ $t('promotion.tradingRewards.tncLink') }}</a>
      </span>
    </el-checkbox>
    <div v-if="showError" class="text-red">
      {{ $t('common.formValidation.tnc') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  props: {
    tncUrl: String,
    isAgreeTnc: Boolean,
    showError: Boolean
  },
  data() {
    return { agreeTnc: false };
  },
  watch: {
    isAgreeTnc(boolean) {
      this.agreeTnc = boolean;
    },
    agreeTnc(bool) {
      this.$emit('update:isAgreeTnc', bool);
      if (bool) this.$emit('update:showError', !bool);
    }
  }
};
</script>

<style lang="scss" scoped>
.tncWrapper {
  a {
    font-weight: 400;
    color: blue;
    text-decoration: underline;
    padding: 0 5px;
    &:hover {
      text-decoration: underline !important;
    }
  }
  .text-red {
    font-size: 14px;
  }

  @media (max-width: 550px) {
    span {
      font-size: 12px;
    }
  }
  /deep/ .el-checkbox .el-checkbox__label {
    width: auto;
  }
}
</style>
